export default __webpack_public_path__ + "static/media/faralya1.faa6afd6.jpg";